<template>
  <div class="alerts-block">
    <label class="a-alert" for="IsAlert" v-if='alertEntity.IsAlert'>
        <span class="alert-block"></span>
    </label>
    <label class="flex-alert" for="IsFlexAlert" v-if='alertEntity.IsFlexAlert'>
        <span class="alert-block"></span>
    </label>
    <label class="contract-end-alert" for="IsContractEnd" v-if='alertEntity.IsContractEnd'>
        <span class="alert-block"></span>
    </label>
    <label class="mileage-alert" for="IsMileageAlert" v-if='alertEntity.IsMileageAlert'>
        <span class="alert-block"></span>
    </label>
    <label class="warranty-alert" for="IsWarrantyAlert" v-if='alertEntity.IsWarrantyAlert'>
        <span class="alert-block"></span>
    </label>
    <label class="service-alert" for="IsService" v-if='alertEntity.IsService'>
        <span class="alert-block"></span>
    </label>
    <label class="pending-service-alert" for="IsAppointment" v-if='alertEntity.IsAppointment'>
        <span class="alert-block"></span>
    </label>
    <label class="in-market-alert" for="IsInMarket" v-if='alertEntity.IsInMarket'>
        <span class="alert-block"></span>
    </label>
    <label class="engaged-alert" for="IsInMarketEngaged" v-if='alertEntity.IsInMarketEngaged'>
        <span class="alert-block"></span>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'alertsBlock',
    data: function (){
      return {}
    },
    props: [
      'alertEntity'
    ],
    created(){}
  }
</script>

<style lang='scss' scoped>
  .alerts-block {
    display:inline;
    label {
      margin:0;
    }
  }
  .alert-block {
    border-radius: 3px;
    text-align: center;
    line-height: 19px;
    &::before {
      color: #fff;
      font-weight: 600;
      font-size: 13px;
      border-radius: 3px;
      display: inline-block;
      width: 18px;
      height: 18px;
    }
  }
  .a-alert .alert-block::before {
    content: "A";
    background-color: #ED2124;
  }
  .flex-alert .alert-block::before {
    content: "F";
    background-color: #7A4119;
  }
  .contract-end-alert .alert-block::before {
    content: "C";
    background-color: #1F8BD5;
  }
  .mileage-alert .alert-block::before {
    content: "M";
    background-color: #FF6100;
  }
  .warranty-alert .alert-block::before {
    content: "W";
    background-color: #7B5ACB;
  }
  .service-alert .alert-block::before {
    content: "S";
    background-color: #3FAF49;
  }
  .pending-service-alert .alert-block::before {
    content: "P";
    background-color: #257f31;
  }
  .in-market-alert .alert-block::before {
    content: "I";
    background-color: #c80;
  }
  .engaged-alert .alert-block::before {
    content: "E";
    background-color: #fcaf26;
  }
</style>



// WEBPACK FOOTER //
// src/components/Icons/AlertsBlock.vue